import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomerGroupFilterState } from "src/types";

import { Dispatch, StoreState } from "../../store";
import Autocomplete from "../Autocomplete";
import { FilterGroup } from "./constants";
import FilterContainer from "./FilterContainer";

interface Props {
  enabled: boolean;
  handleEnabledChange: (filterGroup: FilterGroup, checked: boolean) => void;
  changeCustomerGroupFilter: (
    payload: Partial<CustomerGroupFilterState>
  ) => void;
  housingSituationsFilter: { buildingTypes: number[]; buildingAges: number[] };
}

const HousingSituationsFilter: React.FC<Props> = ({
  enabled,
  handleEnabledChange,
  changeCustomerGroupFilter,
  housingSituationsFilter,
}: Props) => {
  const dispatch = useDispatch<Dispatch>();
  const housingSituations = useSelector(
    (state: StoreState) => state.housingSituations
  );

  useEffect(() => {
    dispatch.housingSituations.fetchHousingSituations(null);
  }, [dispatch]);

  const handleChangeBuildingTypesFilter = (
    value: Array<{ label: string; value: string }>
  ) => {
    changeCustomerGroupFilter({
      housingSituationsFilter: {
        ...housingSituationsFilter,
        buildingTypes: value.map((value) => parseInt(value.value)),
      },
    });
  };

  const handleChangeBuildingAgesFilter = (
    value: Array<{ label: string; value: string }>
  ) => {
    changeCustomerGroupFilter({
      housingSituationsFilter: {
        ...housingSituationsFilter,
        buildingAges: value.map((value) => parseInt(value.value)),
      },
    });
  };

  return (
    <FilterContainer
      enabled={enabled}
      title="Wohnsituation"
      onEnabledChange={(enabled) => {
        handleEnabledChange(FilterGroup.housingSituations, enabled);
      }}
    >
      {(disabled?: boolean) => (
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <Autocomplete
              disabled={disabled}
              options={housingSituations.buildingTypes.map((buildingType) => ({
                label: buildingType.name,
                value: buildingType.id.toString(),
              }))}
              value={housingSituationsFilter.buildingTypes.map((id) => ({
                label:
                  housingSituations.buildingTypes.find(
                    (buildingType) => buildingType.id === id
                  )?.name ?? "",
                value: id.toString(),
              }))}
              onChange={handleChangeBuildingTypesFilter}
              label="Gebäudetyp auswählen"
              placeholder="Bitte auswählen..."
            />
          </Grid>

          <Grid item={true} xs={12}>
            <Autocomplete
              disabled={disabled}
              options={housingSituations.buildingAges.map((buildingAge) => ({
                label: buildingAge.name,
                value: buildingAge.id.toString(),
              }))}
              value={housingSituationsFilter.buildingAges.map((id) => ({
                label:
                  housingSituations.buildingAges.find(
                    (buildingAge) => buildingAge.id === id
                  )?.name ?? "",
                value: id.toString(),
              }))}
              onChange={handleChangeBuildingAgesFilter}
              label="Gebäudealter auswählen"
              placeholder="Bitte auswählen..."
            />
          </Grid>
        </Grid>
      )}
    </FilterContainer>
  );
};

export default HousingSituationsFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/HousingSituationsFilter.tsx